import { render, staticRenderFns } from "./LearningPre.vue?vue&type=template&id=6ad276c8&scoped=true&"
import script from "./LearningPre.vue?vue&type=script&lang=js&"
export * from "./LearningPre.vue?vue&type=script&lang=js&"
import style0 from "./LearningPre.vue?vue&type=style&index=0&id=6ad276c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad276c8",
  null
  
)

export default component.exports